import {Options} from "../common/inputs/select/select";

export const status = {
    PROCESSING: 'processing',
    DOWNLOADED: 'downloaded',
    ERROR: 'error',
    COMPLETED: 'completed',
    CONFLICT: 'conflict',
} as const;

export const UserRole = {
    SUPERADMIN: 'superAdmin',
    ADMIN: 'admin',
    USER: 'user',
} as const;


export const roles: Options[] = [
    {label: 'User', value: UserRole.USER},
    {label: 'Super Admin', value: UserRole.SUPERADMIN},
    {label: 'Admin', value: UserRole.ADMIN},
] as const;

export const currency: Options[] = [
    {value: 'eur', label: 'EUR'},
    {value: 'usd', label: 'USD'}
] as const;

export const BillingType = {
    FIXED: 'fixed',
    HOURLY: 'hourly'
}
export const billingTypeOptions: Options[] = [
    {value: 'fixed', label: 'Fixed'},
    {value: 'hourly', label: 'Hourly'}
] as const;

// export const Resources = {
//     ORGANIZATION: 'Organization',
//     CUSTOMER: 'Customer',
//     CONTRACT: 'Contract',
//     COSTPOSITION: 'Cost Position',
//     TASKORDER: 'Task Order',
//     TASKORDERCOSTPOSITION: 'Task Order Cost Position',
//     IMPORT: 'Import',
//     REPORT: 'Report',
//     USER: 'User',
//     UTILIZATIONLOG: 'Utilization Log',
//     CHANGELOG: 'Change Log'
// }

export const Resources = {
    ORGANIZATION: 'Organization',
    CUSTOMER: 'Kunden',
    CONTRACT: 'Verträge',
    COSTPOSITION: 'Kostenpositionen',
    TASKORDER: 'Task Order',
    TASKORDERCOSTPOSITION: 'Kostenpositionen',
    IMPORT: 'Import',
    REPORT: 'Report',
    USER: 'Benutzer',
    UTILIZATIONLOG: 'Utilization Log',
    CHANGELOG: 'Change Log'
}

// export const FormMode = {
//     CREATE: 'Create',
//     VIEW: 'View',
//     DELETE: 'Delete',
//     EDIT: 'Edit',
//     READONLY: 'readOnly',
//     DOWNLOAD: 'Download',
// }

export const FormMode = {
    CREATE: 'Create',
    VIEW: 'Bearbeiten',
    DELETE: 'Löschen',
    EDIT: 'Bearbeiten',
    READONLY: 'readOnly',
    DOWNLOAD: 'Download',
    UPDATE: 'Update',
}

export const Status = {
    PROCESSING: 'processing',
    COMPLETED: 'completed',
    ERROR: 'error',
    DOWNLOADED: 'downloaded',
    CONFLICT: 'conflict',
} as const

export type StatusValue = typeof Status[keyof typeof Status];

export const ImportStatusOptions: Options[] = [{
    label: 'Processing',
    value: Status.PROCESSING,
},
    {
        label: 'Completed',
        value: Status.COMPLETED,
    },
    {
        label: 'Error',
        value: Status.ERROR,
    },
    {
        label: 'Conflict',
        value: Status.CONFLICT,
    },
]

const COUNTRY_LABELS: string[] = [
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia',
    'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium',
    'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria',
    'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad',
    'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Côte d’Ivoire', 'Croatia', 'Cuba', 'Cyprus',
    'Czechia', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
    'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji',
    'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea',
    'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq',
    'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait',
    'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania',
    'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania',
    'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique',
    'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria',
    'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine State', 'Panama',
    'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia',
    'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino',
    'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore',
    'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain',
    'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand',
    'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda',
    'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States of America', 'Uruguay', 'Uzbekistan',
    'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

const slug = (s: string) => s.toLowerCase().replace(/\s+/g, '-');
export const CountryOptions = COUNTRY_LABELS.map(label => ({label, value: slug(label)}));

const ReportType = {
    FINANCIAL: 'financial'
}

export const ReportTypeOptions: Options[] = [{label: 'Financial', value: ReportType.FINANCIAL}]